import React from 'react';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export function showImportantAlert(): Promise<void> {
  return MySwal.fire({
    html: (
      <div style={{ maxWidth: '800px', textAlign: 'left' }}>
        <h1
          style={{
            color: '#d9534f',
            textAlign: 'center',
            fontSize: '24px',
            marginBottom: '20px',
            fontWeight: 'bold',
          }}
        >
          ATENÇÃO
        </h1>

        <h2
          style={{
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '15px',
            color: '#333',
          }}
        >
          Servidor
        </h2>

        <div
          style={{
            backgroundColor: '#f8f9fa',
            padding: '15px',
            borderRadius: '5px',
            marginBottom: '20px',
            borderLeft: '4px solid #d9534f',
          }}
        >
          <p style={{ marginBottom: '10px' }}>
            Informação Importante, conforme <b>Lei 7.524/2024</b>,{' '}
            <b>Decretos 28.195/20027</b>, <b>46.102/2024</b> e{' '}
            <b>Edital de credenciamento nº 01/2024</b>, é exigida a comprovação
            de sua adesão ao Plano Odontológico para efetivação da consignação
            junto ao seu órgão de lotação.
          </p>

          <p style={{ marginBottom: '10px' }}>
            Assim, a contratação e ativação do plano ocorrerá mediante a
            confirmação de sua assinatura no documento disponibilizado no seu
            email e enviado para o seu WhatsApp no telefone cadastrado.
          </p>

          <p style={{ marginBottom: '0', fontWeight: 'bold' }}>
            Clique no link recebido e assine o documento.
          </p>
        </div>

        <hr
          style={{
            borderTop: '1px dashed #ccc',
            margin: '20px 0',
          }}
        />

        <div
          style={{
            marginTop: '30px',
            textAlign: 'right',
            fontStyle: 'italic',
            color: '#666',
          }}
        >
          <p style={{ margin: '0' }}>
            Atte.
            <br />
            Odontogroup
          </p>
        </div>
      </div>
    ),
    showCloseButton: true,
    closeButtonHtml: '&times;',
    background: '#fff',
    width: '850px',
    padding: '2rem',
    confirmButtonText: 'Entendi',
    confirmButtonColor: '#d9534f',
    customClass: {
      closeButton: 'custom-close-button',
    },
  }).then();
}
